'use client';

import { useEffect } from 'react';

export function PlanChunkErrorHandler() {
    useEffect(() => {
        // Handle chunk loading errors
        const handleChunkError = (event: ErrorEvent) => {
            const error = event.error;
            if (error && error.message && error.message.includes('Loading chunk')) {
                console.error('Chunk loading error detected:', error);
                // Try to reload the page after a short delay
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        };

        // Listen for chunk loading errors
        window.addEventListener('error', handleChunkError);

        return () => {
            window.removeEventListener('error', handleChunkError);
        };
    }, []);

    return null;
}

